<template>
  <div>
    <h3>Chấm bài tự luận</h3>
    <hr>
    <div class="p-8 rounded-lg d-flex" style="background: #f9f7fb; align-items: center;">
      <div class="row w-100">
        <div class="d-flex col-md-4">
          <span class="font-weight-bold" style="min-width: 100px">Học viên: </span>
          <b>{{ mark_essay?.student?.name }}</b>
        </div>
        <div class="d-flex col-md-4 my-3 my-md-0">
          <span class="font-weight-bold" style="min-width: 100px">Số điện thoại:</span>
          <b>{{ mark_essay?.student?.phone }}</b>
        </div>
        <div class="d-flex col-md-4 mb-3 mb-md-0">
          <span class="font-weight-bold" style="min-width: 100px">Buổi học:</span>
          <b>{{ lesson }}</b>
        </div>
      </div>
    </div>
    <div class="rounded-lg mt-5">
      <!-- <CommentAnswer v-if="answerOfStudent.length > 0 && !isCambridgeMentor()"
          :group-questions="answerOfStudent"
          :typeMark="score_max_homework"
          :course_student_id="course_student_id"
      /> -->
      <MakeHomeworkContainer v-if="answerOfStudent.length > 0 && !isCambridgeMentor()"
          :group-questions="answerOfStudent"
          :typeCourse="score_max_homework"
          :course_student_id="course_student_id"
          :overall_id="overall_id"
      />
     <CommentAnswerKid v-if="answerOfStudent.length > 0 && isCambridgeMentor()"
      :group-questions="answerOfStudent"
      :typeMark="score_max_homework"
      :course_student_id="course_student_id"
     >
     </CommentAnswerKid>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADMIN_GET_MARK_HOMEWORK,
  ADMIN_HOMEWORK,
} from "@/core/services/store/course/classes.module";
import moment from "moment-timezone";
import CommentAnswer from "./components/CommentAnswer.vue";
import {AnswerStudent} from "@/view/pages/classes/model/AnswerStudent";
import {Cambridge_Mentor_ID} from "@/core/option/typeCenterBill";
import CommentAnswerKid from "@/view/pages/classes/components/CommentAnswerKid.vue";
import {GET_EXAM_MARK_TUTOR} from "../../../core/services/store/course/classes.module";
import MakeHomeworkContainer from "./mark-homework/MakeHomeworkContainer.vue";
import { RECORD_VIDEO, RECORD_AUDIO} from "./mark-homework/constant";

export default {
  components: {CommentAnswerKid, CommentAnswer, MakeHomeworkContainer },
  data() {
    return {
      mark_essay: {
        isLoadingMarkEssay: true,
        student: {},
        data: [],
      },
      lesson: null,
      classroom_id: null,
      student_id: null,
      course_student_id: null,
      time_send_homework: null,
      loading: false,
      score_max_homework: 0,
      answerOfStudent: [],
      isTutor: false,
      RECORD_AUDIO,
      RECORD_VIDEO,
      overall_id: null,
    }
  },
  async mounted() {
    let view_result = this.$route.query.type;
    this.isTutor = +this.$route.query.isTutor === 1
    this.lesson = this.$route.params.id;
    if (view_result) {
      this.typeView = "mark-homework";
      this.lesson = this.$route.query.lesson;
    }
    if(this.isTutor){
      this.lesson = this.$route.query.lesson;
    }
    this.classroom_id = this.$route.query.classroom_id
    this.student_id = this.$route.query.student_id
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Quản lý lớp học", route: 'schedule-class', id: this.$route.query.classroom_id },
      { title: "Chấm điểm bài tập về nhà" }
    ]);
    await this.getExamStudent()
  },
  methods: {
    async getExamStudent() {
      this.isloadingHomework = true;
      if (this.isTutor) {
        await this.getMarkStudentTutor()
      } else {
        await this.getMarkStudent()
      }
      this.isloadingHomework = false;
    },
    defaultSpeakingEvaluation() {
      return {
        evaluationStatus: 'pass',
        notMeetReason: '',
        notMeetDescription: ''
      }
    },
    async getMarkStudentTutor() {
      const payload = {
        classroom_id: this.classroom_id,
        lesson: this.lesson,
        user_id: this.student_id,
        type: 'homework'
      }
      await this.$store.dispatch(ADMIN_HOMEWORK, payload).then(res => {
        if (!res.error) {
          if (res.data.length > 0) {
            this.mark_essay.student = res.data[0];
            this.score_max_homework = res.data[0].score_max_homework
            this.course_student_id = res.data[0].course_student_id
            this.overall_id = res.data[0].test?.overall_id
            let payloadTutor = {
              classroom_id: this.classroom_id,
              overall_id: res.data[0].test?.overall_id,
              lesson: this.lesson,
              student_id: this.student_id,
            }
            this.$store.dispatch(GET_EXAM_MARK_TUTOR, payloadTutor).then((res) => {
              if (!res.error) {
                this.mark_essay.data = res.data;
                const processedHomework = this.mark_essay?.data.map((e)=>{
                  let typeAnswer = e?.group_question?.type
                  return  new AnswerStudent(e.comment,e.comments,e.group_question,e.outcomes_id,e.overall_result_id,e.score,e.score_detail,e.status_mark,e.student_answer,e.test_id,e.type,e.user_id,typeAnswer)
                })
                this.answerOfStudent = this.transformGroupSpeaking(processedHomework)
                this.mark_essay.isLoadingMarkEssay = false;
              }
            }).catch((e) => {
              console.log(e, 'error')
            });
            this.time_send_homework = moment(this.mark_essay.student.created_at).format('HH:mm:ss YYYY-MM-DD')
            this.isLoadingMarkEssay = false;
          }
        }
      })
    },

    // tranform group speaking
    transformGroupSpeaking(processedHomework) {
      // Group speaking homework items together
      const groupedHomework = []
        const speakingItems = []

        processedHomework?.forEach((homework) => {
          if ([RECORD_VIDEO, RECORD_AUDIO].includes(homework?.typeAnswer)) {
            speakingItems.push(homework)
          } else {
            groupedHomework.push(homework)
          }
        })

        // Add grouped speaking items if any exist
        if (speakingItems.length > 0) {
          groupedHomework.push({
            type_group: "speaking",
            data: speakingItems,
            speakingEvaluation: this.defaultSpeakingEvaluation(),
            evaluations: {
              fluency: { score: null, comment: null },
              vocabularyRange: { score: null, comment: null },
              grammaticalRange: { score: null, comment: null },
              pronunciation: { score: null, comment: null }
            },
          })
        }
        return groupedHomework;
    },

    async getMarkStudent() {
      this.isloadingHomework = true;
      this.$store.dispatch(ADMIN_HOMEWORK, {
        classroom_id: this.classroom_id,
        lesson: this.lesson,
        type: 'homework',
        user_id: this.student_id
      }).then((res) => {
        if (!res.error) {
          if (res.data.length > 0) {
            this.mark_essay.student = res.data[0];
            this.score_max_homework = res.data[0].score_max_homework
            this.course_student_id = res.data[0].course_student_id
            let payload = {
              classroom_id: this.classroom_id,
              course_student_id: res.data[0].course_student_id,
              overall_id: res.data[0].test.overall_id
            }
            this.$store.dispatch(ADMIN_GET_MARK_HOMEWORK, payload).then((res) => {
              if (!res.error) {
                this.mark_essay.data = res.data;
                console.log(this.mark_essay.data, 'mark_essay.data')
                const processedHomework = this.mark_essay?.data.map((e)=>{
                  let typeAnswer = e?.group_question?.type
                 return  new AnswerStudent(e.comment,e.comments,e.group_question,e.outcomes_id,e.overall_result_id,e.score,e.score_detail,e.status_mark,e.student_answer,e.test_id,e.type,e.user_id,typeAnswer)
                })
                this.answerOfStudent = this.transformGroupSpeaking(processedHomework)
                console.log(this.answerOfStudent, 'answerOfStudent')
                this.mark_essay.isLoadingMarkEssay = false;
              }
            }).catch((e) => {
              console.log(e, 'error')
            });
            this.time_send_homework = moment(this.mark_essay.student.test.created_at).format('HH:mm:ss YYYY-MM-DD')
            this.isLoadingMarkEssay = false;
          }
        }
      }).catch((e) => {
        console.log(e, 'error')
      });
    },
    isCambridgeMentor() {
      const idCenter = this.$route.query.center_id;
      return +idCenter === Cambridge_Mentor_ID
    }
  },

}
</script>

<style lang="scss" scoped>
.btn-custom {
  padding: 8px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  align-self: center;

  :hover {
    background-color: burlywood;
  }
}
</style>